// extracted by mini-css-extract-plugin
module.exports = {"promotion":"_2_donationAmount_promotion_1yvc9","text":"_2_donationAmount_text_1JbqQ"};